"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceZoneProductPriceConverter_1 = require("../../cleaning/conversions/dto/PriceZoneProductPriceConverter");

var InternalProductPricesDTO_1 = require("../model/InternalProductPricesDTO");

var PriceArchitectureExportDTO_1 = require("../model/PriceArchitectureExportDTO");

var PriceArchitectureExportDTOConverter_1 = require("./PriceArchitectureExportDTOConverter");

var PriceArchitectureExportDTOConverterImpl =
/*#__PURE__*/
function (_PriceArchitectureExp) {
  _inherits(PriceArchitectureExportDTOConverterImpl, _PriceArchitectureExp);

  function PriceArchitectureExportDTOConverterImpl(priceZoneProductPriceConverter) {
    var _this;

    _classCallCheck(this, PriceArchitectureExportDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceArchitectureExportDTOConverterImpl).call(this));
    _this.priceZoneProductPriceConverter = priceZoneProductPriceConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceArchitectureExportDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceArchitectureExportDTO_1.PriceArchitectureExportDTO(PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.externalId.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.name.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel6.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel5.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel4.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel3.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel2.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.categoryLevel1.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.leader.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.family.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.tier.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.ratio.valueOf(source.ratio ? conversions.toBigNumber(source.ratio) : null), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.charger.valueOf(source.charger ? conversions.toBigNumber(source.charger) : null), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.flags.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.supplier.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.priceSensitivity.valueOfField(source), PriceArchitectureExportDTO_1.PriceArchitectureExportDTO.schema.purchasePrice.valueOf(source.purchasePrice ? conversions.toBigNumber(source.purchasePrice) : null), InternalProductPricesDTO_1.InternalProductPricesDTO.schema.prices.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        categoryLevel6: source.categoryLevel6,
        categoryLevel5: source.categoryLevel5,
        categoryLevel4: source.categoryLevel4,
        categoryLevel3: source.categoryLevel3,
        categoryLevel2: source.categoryLevel2,
        categoryLevel1: source.categoryLevel1,
        leader: source.leader,
        family: source.family,
        tier: source.tier,
        ratio: conversions.fromBigNumber(source.ratio),
        charger: conversions.fromBigNumber(source.charger),
        flags: source.flags,
        supplier: source.supplier,
        priceSensitivity: source.priceSensitivity,
        purchasePrice: conversions.fromBigNumber(source.purchasePrice),
        prices: conversions.asObjectArray(source, 'prices', function (p) {
          return _this2.priceZoneProductPriceConverter.toDocument(p, conversions);
        })
      });
      return result;
    }
  }]);

  return PriceArchitectureExportDTOConverterImpl;
}(PriceArchitectureExportDTOConverter_1.PriceArchitectureExportDTOConverter);

PriceArchitectureExportDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceZoneProductPriceConverter_1.PriceZoneProductPriceConverter])], PriceArchitectureExportDTOConverterImpl);
exports.PriceArchitectureExportDTOConverterImpl = PriceArchitectureExportDTOConverterImpl;